import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-st-product",
  "use": "icon-st-product-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-st-product\">\n    <path d=\"M5 7H16C20.4183 7 24 10.5817 24 15V42C24 38.6863 21.3137 36 18 36H5V7Z\" fill=\"none\" stroke=\"rgba(23, 35, 22, 1)\" stroke-width=\"4\" stroke-linejoin=\"round\" /><path d=\"M43 7H32C27.5817 7 24 10.5817 24 15V42C24 38.6863 26.6863 36 30 36H43V7Z\" fill=\"none\" stroke=\"rgba(23, 35, 22, 1)\" stroke-width=\"4\" stroke-linejoin=\"round\" />\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol